import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { t } from 'i18next'

dayjs.extend(utc)
dayjs.extend(timezone)

export const BERLIN_TZ = 'Europe/Berlin'

// Date object whose local wall-clock fields show the current time in Berlin,
// regardless of the device timezone. Only meant for prefilling date/time
// pickers under the "all times are German time" convention - it does NOT
// represent the correct absolute instant.
export function getBerlinNow() {
    return new Date(dayjs().tz(BERLIN_TZ).format('YYYY-MM-DDTHH:mm:ss'))
}

export function formatBerlinTimeNow() {
    return dayjs().tz(BERLIN_TZ).format('HH:mm')
}

// Renders a stored UTC delivery timestamp as device-local time. When the
// viewer's timezone shows a different wall-clock than Berlin, the German
// time is appended, e.g. "03:12 (07:12 deutsche Zeit)".
export function formatDeliveryTime(deliveryDate, deliveryTime) {
    const instant = dayjs.utc(deliveryDate + ' ' + deliveryTime)
    const local = instant.local().format('HH:mm')
    const berlin = instant.tz(BERLIN_TZ).format('HH:mm')

    if (local === berlin) {
        return local
    }

    return `${local} (${berlin} ${t('contracts.details.delivery.german_time')})`
}
